// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"271":"9507e069","327":"4f034e44","431":"92fc8a06","638":"4f034e44","715":"7264795c","719":"b8d2b14c","884":"51ac22d6","987":"4f034e44"}[chunkId] + ".css";
};